var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckWhite = function SvgIconCheckWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.68 4.008a.89.89 0 0 1-.001 1.26l-6.737 6.725a.89.89 0 0 1-1.26 0L2.32 8.63a.891.891 0 1 1 1.26-1.26l2.733 2.733 6.107-6.096a.89.89 0 0 1 1.26.001",
    clipRule: "evenodd"
  })));
};
export default SvgIconCheckWhite;